import { useState } from 'react';
import ConfirmModal from '../components/common/ConfirmModal';

export const useConfirmation = () => {
  const [confirmModal, setConfirmModal] = useState(null);

  const confirm = (title, message, type = 'danger', confirmText = 'Confirm', cancelText = 'Cancel') => {
    return new Promise((resolve) => {
      setConfirmModal({
        title,
        message,
        type,
        confirmText,
        cancelText,
        resolve
      });
    });
  };

  const ConfirmationModal = () => {
    if (!confirmModal) return null;

    return (
      <ConfirmModal
        isOpen={true}
        onClose={() => {
          confirmModal.resolve(false);
          setConfirmModal(null);
        }}
        onConfirm={() => {
          confirmModal.resolve(true);
          setConfirmModal(null);
        }}
        title={confirmModal.title}
        message={confirmModal.message}
        confirmText={confirmModal.confirmText}
        cancelText={confirmModal.cancelText}
        type={confirmModal.type}
      />
    );
  };

  return { confirm, ConfirmationModal };
};
